import { api, app } from "../../app"
import { Icon, Modal } from "antd"
import PayTemplate from "../../components/PayTemplate"
import React from "react"

const common = {
    /**
     * 订单支付
     * @param orders_no
     * @returns {Promise<any>}
     */
    pay: (orders_no) => {
        return new Promise((resolve) => {
            const params = {
                orders_no,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            app.post(api.OrdersZhifu, params).then(({ flag, data, msg }) => {
                if (flag === 1) {
                    window.location.href = data
                } else {
                    app.alert(msg, 'warn')
                }
                resolve(data)
            })
        })
    },
    /**
     * 订单支付2
     * @param orders_no
     * @returns {Promise<any>}
     */
    pay2: (orders_no) => {
        return new Promise((resolve) => {
            app.alert("正在加载支付...", 'loading', '45%', 0)
            const params = {
                orders_no,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            app.post(api.OrdersZhifu, params).then(({ flag, data, msg }) => {
                app.alertDestroy()
                if (flag === 1) {
                    Modal.confirm({
                        title: '扫码支付',
                        centered: true,
                        icon: (<Icon type="alipay-circle" style={{ color: '#00A1E9' }}/>),
                        width: 600,
                        content: (
                            <PayTemplate qrcode={data.qrUrl} money={data.totalAmount} no={data.orderCode}/>),
                        okText: '已支付',
                        cancelText: '关闭',
                        onOk: async () => {
                            const { flag, msg } = await app.post(api.MConfirmPay, {
                                indexno: app.getData('indexno'),
                                account: app.getData('account'),
                                order_code: data.orderCode
                            })
                            if (flag === 1) {
                                app.alert('支付成功', 'success')
                                resolve(true)
                                return true
                            } else {
                                app.alert(msg, 'warn')
                                resolve(false)
                                throw false
                            }
                        },
                        onCancel: () => {
                            resolve(false)
                        }
                    })
                } else {
                    app.alert(msg, 'error')
                    resolve(false)
                }
            }).catch(() => {
                app.alert('支付失败', 'error')
                resolve(false)
            })
        })
    },
    /**
     * 订单取消
     * @param orders_id
     * @returns {Promise<any>}
     */
    cancel: (orders_id) => {
        return new Promise((resolve) => {
            const params = {
                orders_id,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            app.post(api.MyOrdersCancel, params).then(({ flag, data, msg }) => {
                if (flag === 1) {
                    resolve(resolve)
                } else {
                    app.alert(msg, 'warn')
                }
                resolve(data)
            })
        })
    },

    order_state: [
        { id: '10', name: '全部订单' },
        { id: '13', name: '待审核' },
        { id: '0', name: '待付款' },
        { id: '1', name: '排产中' },
        { id: '2', name: '生产中' },
        { id: '3', name: '已发货' },
        { id: '4', name: '无法生产' },
        { id: '5', name: '待发货' },
        { id: '6', name: '重复订单' },
        { id: '7', name: '等待重新处理' },
        { id: '8', name: '不生产' },
        { id: '9', name: '已收货' },
        { id: '11', name: '已退款' },
        { id: '12', name: '已挂失' },
    ],
}

export default common



// WEBPACK FOOTER //
// ./src/routes/cart/common.js